import { render, staticRenderFns } from "./PedidoContainer.vue?vue&type=template&id=75b383ec&scoped=true"
import script from "./PedidoContainer.vue?vue&type=script&lang=js"
export * from "./PedidoContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b383ec",
  null
  
)

export default component.exports